import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemText from "@mui/material/ListItemText";
import Chip from "@mui/material/Chip";

import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";

import api from "services/api";
import { requireAuth } from "actions/AuthAction";

function DetailLayanan() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [jenis, setJenis] = useState(null);
  const [syarat, setSyarat] = useState([]);
  const [submitting, setSubmitting] = useState(false);

  useEffect(() => {
    const user = requireAuth(navigate, ["PEMOHON"]);
    if (!user) return;

    Promise.all([api.get(`jenis-izin/${id}`), api.get(`jenis-izin/${id}/syarat`)])
      .then(([jenisRes, syaratRes]) => {
        setJenis(jenisRes.data?.data);
        setSyarat(syaratRes.data?.data || []);
      })
      .catch(() => alert("Gagal memuat detail layanan"))
      .finally(() => setLoading(false));
  }, [id, navigate]);

  const handleBuatPengajuan = async () => {
    setSubmitting(true);
    try {
      const res = await api.post("pengajuan", { jenis_izin_id: Number(id) });
      const pengajuan = res.data?.data;
      navigate(`/pengajuan/${pengajuan.id}`);
    } catch (err) {
      alert(err.response?.data?.message || "Gagal membuat pengajuan");
    } finally {
      setSubmitting(false);
    }
  };

  if (loading) {
    return (
      <DashboardLayout>
        <DashboardNavbar />
        <MDBox p={3}>Memuat...</MDBox>
      </DashboardLayout>
    );
  }

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox py={3}>
        <Grid container spacing={3}>
          <Grid item xs={12} lg={8}>
            <Card>
              <MDBox p={3}>
                <MDTypography variant="h5" fontWeight="medium" mb={1}>
                  {jenis?.nama}
                </MDTypography>
                <MDBox display="flex" gap={1} mb={2}>
                  <Chip label={jenis?.sektor} size="small" />
                  <Chip label={jenis?.kategori} size="small" color="info" />
                  {jenis?.perlu_rekomendasi_teknis ? (
                    <Chip label="Rekomendasi Teknis" size="small" color="warning" />
                  ) : null}
                  {jenis?.perlu_pemeriksaan_lapangan ? (
                    <Chip label="Pemeriksaan Lapangan" size="small" color="error" />
                  ) : null}
                </MDBox>
                <MDTypography variant="button" color="text" mb={2} display="block">
                  Output: {jenis?.output || "Dokumen Izin"} • Waktu: {jenis?.waktu_layanan}
                </MDTypography>

                <MDTypography variant="h6" mb={1}>
                  Persyaratan ({syarat.length})
                </MDTypography>
                <List dense>
                  {syarat.map((s, idx) => (
                    <ListItem key={s.id} divider={idx < syarat.length - 1}>
                      <ListItemText
                        primary={`${idx + 1}. ${s.nama_syarat}`}
                        secondary={`${s.jenis_input}${s.wajib ? " • Wajib" : " • Opsional"}`}
                      />
                    </ListItem>
                  ))}
                </List>
              </MDBox>
            </Card>
          </Grid>
          <Grid item xs={12} lg={4}>
            <Card>
              <MDBox p={3}>
                <MDTypography variant="h6" mb={2}>
                  Mulai Pengajuan
                </MDTypography>
                <MDTypography variant="button" color="text" mb={3} display="block">
                  Sistem akan membuat draft pengajuan. Anda dapat mengunggah dokumen
                  persyaratan sebelum submit.
                </MDTypography>
                <MDButton
                  variant="gradient"
                  color="info"
                  fullWidth
                  disabled={submitting}
                  onClick={handleBuatPengajuan}
                >
                  {submitting ? "Memproses..." : "Buat Draft Pengajuan"}
                </MDButton>
                <MDButton
                  variant="text"
                  color="dark"
                  fullWidth
                  sx={{ mt: 1 }}
                  onClick={() => navigate("/layanan")}
                >
                  Kembali
                </MDButton>
              </MDBox>
            </Card>
          </Grid>
        </Grid>
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
}

export default DetailLayanan;
